import React from 'react'
import Note from './Note'

export default () => (
  <Note>
    Loading...
  </Note>
)
